import React from 'react';
import { Alert as MuiAlert, AlertTitle } from '@mui/material';

import { IAlert } from './interfaces';

export const Alert: React.FC<IAlert> = ({
  title,
  children,
  action,
  variant = 'filled',
  severity = 'info',
}): JSX.Element => {
  return (
    <MuiAlert
      variant={variant}
      severity={severity}
      sx={{
        marginBottom: '10px',
      }}
      action={action}
    >
      <AlertTitle
        sx={{
          fontWeight: '700 !important',
        }}
      >
        {title}
      </AlertTitle>
      {children}
    </MuiAlert>
  );
};
